<template>
    <div class="CAll">
        <!-- 头部导航  已更新样式-->
        <div class="header">
            <div class="header-left">
                <div class="logo-container" @click="backIndex">
                    <img src="@/assets/img/bhLogo.png" alt="" class="logo-icon">
                    <div style="display: flex;flex-direction: column;">
                        <div class="bhText" style="margin-bottom: 4px;">佰衡（河北）企业管理集团有限公司</div>
                        <!-- 公司英文 -->
                        <div class="bhDesc">Baiheng (Hebei) Enterprise Management Group Co., Ltd.</div>
                    </div>
                </div>
                <!-- <div class="user-info">
                    <div class="user-avatar">{{ userInfo.name.charAt(0) }}</div>
                    <div class="user-details">
                        <span class="user-name">{{ userInfo.name }}</span>
                        <span class="user-role">{{ userInfo.role === 'admin' ? '管理员' : '普通员工' }}</span>
                    </div>
                </div> -->
            </div>
            <div class="header-right">
                <div v-if="hasManagerRole" class="float-btn-group">
                    <div class="audit-float-btn" @click="goAudit">
                        <i class="el-icon-s-check"></i>
                        <span>请款审阅</span>
                        <span v-if="auditPendingCount > 0" class="audit-badge">{{ auditPendingCount }}</span>
                    </div>
                    <div class="view-audit-float-btn" @click="goApplicationForm">
                        <i class="el-icon-lock"></i>
                        <span>权限审批</span>
                        <span v-if="viewApplyPendingCount > 0" class="audit-badge">{{ viewApplyPendingCount }}</span>
                    </div>
                </div>
                <div class="current-date">
                    <!-- <div class="date-time">{{ currentDate }}</div> -->
                    <div class="greeting">
                        <span>{{ greeting }}，{{ userInfo.name }}</span>
                        <div class="logout-btn" @click="handleLogout">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                <polyline points="16 17 21 12 16 7"></polyline>
                                <line x1="21" y1="12" x2="9" y2="12"></line>
                            </svg>
                            <span>退出</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="emptyContent"></div>


        <div class="maincontent">
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </div>
    </div>
</template>

<script>
import { getToken, removeToken } from '@/utils/auth';
import Cookies from "js-cookie";
import { getAuditPendingCount, getPendingViewApplications } from '@/api/index';
export default {
    data() {
        return {
            isLogin: false,
            currentDate: '',
            greeting: '',
            userInfo: { name: '', roles: [] },
            auditPendingCount: 0,
            viewApplyPendingCount: 0,
        };
    },
    computed: {
        hasManagerRole() {
            return this.userInfo && this.userInfo.roles && this.userInfo.roles.includes('admin')
        }
    },
    mounted() {
        this.isLogin = getToken() ? true : false;
        this.getUserInfoFromCookies();
        this.updateDate();
        setInterval(this.updateDate, 1000);
        this.fetchAuditCount();
        this.fetchViewApplyCount();
        window.addEventListener('auditCountRefresh', this.fetchAuditCount);
        window.addEventListener('viewApplyCountRefresh', this.fetchViewApplyCount);
    },
    beforeDestroy() {
        window.removeEventListener('auditCountRefresh', this.fetchAuditCount);
        window.removeEventListener('viewApplyCountRefresh', this.fetchViewApplyCount);
    },
    methods: {
        async fetchAuditCount() {
            if (!this.hasManagerRole) return;
            try {
                const res = await getAuditPendingCount();
                this.auditPendingCount = res && res.data ? res.data : 0;
            } catch (e) {
                this.auditPendingCount = 0;
            }
        },
        fetchViewApplyCount() {
            if (!this.hasManagerRole) { this.viewApplyPendingCount = 0; return; }
            getPendingViewApplications().then(res => {
                const list = res.rows || res.data || []
                this.viewApplyPendingCount = res.total || 0
            }).catch(() => { this.viewApplyPendingCount = 0 })
        },
        backIndex(){
            window.location.href = '/index';
        },
        // 从cookies中获取用户信息
        getUserInfoFromCookies() {
            const userInfoStr = Cookies.get('userInfo');
            if (userInfoStr) {
                this.userInfo = JSON.parse(userInfoStr)
            }
        },
        updateDate() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = now.getHours();
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            
            // 计算问候语
            if (hours >= 6 && hours < 12) {
                this.greeting = '上午好';
            } else if (hours >= 12 && hours < 18) {
                this.greeting = '下午好';
            } else if (hours >= 18 && hours < 24) {
                this.greeting = '晚上好';
            } else {
                this.greeting = '夜深了';
            }
            
            this.currentDate = `${year}-${month}-${day} ${String(hours).padStart(2, '0')}:${minutes}:${seconds}`;
        },
        // 退出登录
        handleLogout() {
            removeToken();
            localStorage.removeItem('AccessToken_expriesTime');
            Cookies.remove('userInfo');
            location.href = '/loginPage';
        },
        goAudit() {
            this.$router.push('/adminAudit');
        },
        goApplicationForm() {
            this.$router.push('/applicationForm');
        }
    }
};
</script>

<style lang="scss" scoped>
// 高级配色方案
$primary-color: #165DFF;
$primary-light: #4080FF;
$primary-dark: #0E42B4;
$primary-gradient: linear-gradient(135deg, $primary-color 0%, $primary-light 100%);

$success-color: #00B42A;
$success-light: #36D399;
$success-gradient: linear-gradient(135deg, $success-color 0%, $success-light 100%);

$warning-color: #FF7D00;
$warning-light: #FFB020;
$warning-gradient: linear-gradient(135deg, $warning-color 0%, $warning-light 100%);

$info-color: #722ED1;
$info-light: #9254DE;
$info-gradient: linear-gradient(135deg, $info-color 0%, $info-light 100%);

// 文本颜色
$text-primary: #1D2129;
$text-secondary: #4E5969;
$text-muted: #86909C;
$text-light: #F2F3F5;

// 边框颜色
$border-color: #E5E6EB;
$border-light: #F2F3F5;
$border-dark: #C9CDD4;

// 背景颜色
$bg-primary: #F7F8FA;
$bg-secondary: #F2F3F5;
$bg-white: #FFFFFF;
$bg-hover: #F9FAFB;

// 阴影效果
$shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
$shadow-md: 0 4px 12px 0 rgba(0, 0, 0, 0.08);
$shadow-lg: 0 10px 20px 0 rgba(0, 0, 0, 0.12);
$shadow-xl: 0 20px 30px 0 rgba(0, 0, 0, 0.15);

// 边框半径
$border-radius-sm: 6px;
$border-radius-md: 8px;
$border-radius-lg: 12px;
$border-radius-xl: 16px;

// 字体设置
$font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
$font-mono: 'SF Mono', 'Monaco', 'Courier New', monospace;

// 动画设置
$transition-fast: 0.2s ease;
$transition-normal: 0.3s ease;
$transition-slow: 0.4s cubic-bezier(0.4, 0, 0.2, 1);

.CAll {
    min-width: 1280px;
    background: linear-gradient(135deg, #F7F8FA 0%, #E8F0FE 100%);
}

.header {
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(229, 230, 235, 0.8);
    padding: 0 60px;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: $shadow-md;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 100;

    .header-left {
        display: flex;
        align-items: center;
        gap: 60px;

        .logo-container {
            display: flex;
            align-items: center;
            gap: 16px;
            position: relative;
            cursor: pointer;

            .logo-icon {
                width: 50px;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                color: white;
                transition: all $transition-slow;
                position: relative;
                overflow: hidden;

                &::before {
                    content: '';
                    position: absolute;
                    top: -50%;
                    left: -50%;
                    width: 200%;
                    height: 200%;
                    background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                    transform: rotate(45deg);
                    animation: shine 3s infinite;
                }


            }

            .system-title {
                font-size: 28px;
                font-weight: 700;
                color: $text-primary;
                margin: 0;
                letter-spacing: 1px;
                position: relative;
                z-index: 1;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: -6px;
                    left: 0;
                    width: 100%;
                    height: 3px;
                    background: $primary-gradient;
                    transform: scaleX(0);
                    transform-origin: left;
                    transition: transform $transition-normal;
                }

                &:hover::after {
                    transform: scaleX(1);
                }
            }
        }

        .user-info {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 12px 24px;
            background: rgba(242, 243, 245, 0.9);
            border: 1px solid rgba(229, 230, 235, 0.8);
            border-radius: $border-radius-xl;
            backdrop-filter: blur(10px);
            transition: all $transition-normal;
            position: relative;
            overflow: hidden;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(22, 93, 255, 0.1), transparent);
                transition: left $transition-slow;
            }

            &:hover {
                background: rgba(249, 250, 251, 0.95);
                border-color: $primary-light;
                box-shadow: $shadow-md;
                transform: translateY(-2px);

                &::before {
                    left: 100%;
                }
            }

            .user-avatar {
                width: 44px;
                height: 44px;
                border-radius: 50%;
                background: $primary-gradient;
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                font-weight: 600;
                box-shadow: $shadow-sm;
                position: relative;
                overflow: hidden;

                &::before {
                    content: '';
                    position: absolute;
                    top: -50%;
                    left: -50%;
                    width: 200%;
                    height: 200%;
                    background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                    transform: rotate(45deg);
                    animation: shine 4s infinite;
                }
            }

            .user-details {
                display: flex;
                flex-direction: column;
                gap: 4px;

                .user-name {
                    font-size: 16px;
                    font-weight: 600;
                    color: $text-primary;
                }

                .user-role {
                    font-size: 13px;
                    color: $text-secondary;
                    font-weight: 500;
                }
            }
        }
    }

    .header-right {
        display: flex;
        align-items: center;
        gap: 16px;

        .float-btn-group {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        .audit-float-btn {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 8px 18px;
            background: linear-gradient(135deg, #722ED1 0%, #9254DE 100%);
            color: #fff;
            border-radius: 20px;
            cursor: pointer;
            font-size: 13px;
            font-weight: 500;
            box-shadow: 0 2px 8px rgba(114, 46, 209, 0.35);
            transition: all 0.3s ease;
            position: relative;

            i { font-size: 16px; }

            &:hover {
                transform: translateY(-1px);
                box-shadow: 0 4px 14px rgba(114, 46, 209, 0.5);
                background: linear-gradient(135deg, #531DAB 0%, #722ED1 100%);
            }
        }

        .view-audit-float-btn {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 8px 18px;
            background: linear-gradient(135deg, #165DFF 0%, #4080FF 100%);
            color: #fff;
            border-radius: 20px;
            cursor: pointer;
            font-size: 13px;
            font-weight: 500;
            box-shadow: 0 2px 8px rgba(22, 93, 255, 0.35);
            transition: all 0.3s ease;
            position: relative;

            i { font-size: 16px; }

            &:hover {
                transform: translateY(-1px);
                box-shadow: 0 4px 14px rgba(22, 93, 255, 0.5);
                background: linear-gradient(135deg, #0E42B4 0%, #165DFF 100%);
            }
        }

        .audit-badge {
            position: absolute;
            top: -4px;
            right: -4px;
            min-width: 18px;
            height: 18px;
            line-height: 18px;
            padding: 0 5px;
            background: #F53F3F;
            color: #fff;
            font-size: 11px;
            font-weight: 600;
            border-radius: 9px;
            text-align: center;
            border: 2px solid #fff;
            box-shadow: 0 1px 4px rgba(245, 63, 63, 0.4);
        }

        .current-date {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 6px;

            .date-time {
                font-size: 16px;
                color: $text-secondary;
                font-family: $font-mono;
                font-weight: 500;
                padding: 10px 20px;
                background: rgba(242, 243, 245, 0.9);
                border: 1px solid rgba(229, 230, 235, 0.8);
                border-radius: $border-radius-lg;
                backdrop-filter: blur(10px);
                transition: all $transition-normal;

                &:hover {
                    background: rgba(249, 250, 251, 0.95);
                    border-color: $primary-light;
                    box-shadow: $shadow-sm;
                }
            }

            .greeting {
                font-size: 14px;
                color: $text-muted;
                font-weight: 500;
                padding: 0 0;
                position: relative;
                display: flex;
                align-items: center;
                gap: 20px;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: -2px;
                    right: 0;
                    width: 0;
                    height: 1px;
                    background: $primary-gradient;
                    transition: width $transition-normal;
                }

                &:hover::after {
                    width: 100%;
                }

                .logout-btn {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    padding: 6px 12px;
                    background: rgba(22, 93, 255, 0.1);
                    border: 1px solid rgba(22, 93, 255, 0.2);
                    border-radius: $border-radius-md;
                    color: $primary-color;
                    font-size: 13px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all $transition-normal;

                    &:hover {
                        background: $primary-gradient;
                        color: white;
                        border-color: $primary-color;
                        box-shadow: $shadow-sm;
                    }
                }
            }
        }
    }
}

.emptyContent {
    height: 80px;
}

// 动画定义
@keyframes shine {
    0% {
        transform: translateX(-100%) rotate(45deg);
    }

    100% {
        transform: translateX(100%) rotate(45deg);
    }
}

// 响应式设计
@media (max-width: 1280px) {
    .header {
        padding: 0 48px;
        height: 80px;

        .header-left {
            gap: 48px;

            .logo-container {
                gap: 14px;

                .logo-icon {
                    // width: 48px;
                    height: 65px;
                }

                .system-title {
                    font-size: 24px;
                }
            }

            .user-info {
                padding: 10px 20px;
                gap: 14px;

                .user-avatar {
                    width: 40px;
                    height: 40px;
                    font-size: 16px;
                }

                .user-details {
                    .user-name {
                        font-size: 15px;
                    }
                }
            }
        }

        .header-right {
            .current-date {
                .date-time {
                    font-size: 15px;
                    padding: 8px 16px;
                }

                .greeting {
                    font-size: 13px;
                }
            }
        }
    }

    .emptyContent {
        height: 80px;
    }
}

@media (max-width: 768px) {
    .CAll {
        min-width: 100%;
    }

    .header {
        padding: 0 24px;
        height: auto;
        flex-direction: column;
        padding: 28px 24px;
        box-sizing: border-box;
        gap: 24px;

        .header-left {
            flex-direction: column;
            align-items: flex-start;
            gap: 20px;
            width: 100%;

            .logo-container {
                width: 100%;
                justify-content: space-between;
                align-items: center;
            }

            .user-info {
                width: 100%;
                justify-content: space-between;
                padding: 12px 20px;
            }
        }

        .header-right {
            width: 100%;

            .current-date {
                width: 100%;
                align-items: center;

                .date-time {
                    width: 100%;
                    text-align: center;
                    padding: 10px;
                }
            }
        }
    }

    .emptyContent {
        height: auto;
        padding: 20px 0;
    }
}

.maincontent {
    background-color: #FFFFFF;
}
.bhText{
    font-size: 18px;
    font-weight: 550;
}
.bhDesc{
    font-size: 12px;
    color: #333333;
}
</style>